// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-small-item/carousel-article-small-item.component.scss
// module id = 191
// module chunks = 0